export default __webpack_public_path__ + "static/media/mr_mrs_smith_s2.bfb7c3c1.png";